import { createStore } from '@edwin/sdk-admin'
import { ADMIN_ACCESS_TOKEN } from '@const/LocalStorage'

const useStore = createStore({ adminAccessToken: ADMIN_ACCESS_TOKEN })

export default useStore
